import {createContext, ReactNode, useContext, useRef, RefObject} from 'react'

interface ScrollContextType {
    scrollToTop: () => void
    scrollContainerRef: RefObject<HTMLDivElement>
}

const ScrollContext = createContext<ScrollContextType | null>(null)

export const useScrollContext = () => {
    const context = useContext(ScrollContext)
    if (!context) {
        throw new Error('useScrollContext must be used in ScrollProvider')
    }
    return context
}

interface ScrollProviderProps {
    children: ReactNode
}

export const ScrollProvider = ({children}: ScrollProviderProps) => {
    const scrollContainerRef = useRef<HTMLDivElement>(null)

    const scrollToTop = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    }

    const value = {
        scrollToTop,
        scrollContainerRef
    }

    return <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>
}
